var map = {
	"./Mask Group 40.svg": "4c77",
	"./Protect.png": "2518",
	"./forex-trading-1.png": "dc68",
	"./forex-trading-2.png": "d1b2",
	"./forex-trading-3.png": "fb58",
	"./guaranteed-prize.svg": "d17f",
	"./img-1.png": "a1a3",
	"./img-1.svg": "d5d0",
	"./img-11.png": "6335",
	"./img-11.svg": "bbd6",
	"./img-12.png": "b696",
	"./img-2.png": "d389",
	"./img-2.svg": "bcdb",
	"./img-3.png": "10fd",
	"./img-3.svg": "4630",
	"./img-4.png": "8811",
	"./img-4.svg": "b581",
	"./img-5.png": "6666",
	"./img-5.svg": "1332",
	"./img-6.png": "18ed",
	"./img-6.svg": "fe84",
	"./img-7.png": "9579",
	"./img-7.svg": "89d1",
	"./img-8.png": "55f4",
	"./img-8.svg": "cdf3",
	"./img-9.png": "b483",
	"./img-9.svg": "6d8e",
	"./prize-distribution-time.svg": "7174",
	"./right_doc.png": "5c59",
	"./waiting.png": "064f",
	"./winner-certificate.svg": "16a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a5b0";